<template>
    <ubi-page-container wide-main-content>
        <template v-slot:page-actions>
            <el-button
                    @click="enregistrerModif"
                    type="primary"
                    class="inline"
                    v-loading="loading"
            >{{ $t("posts.edit.save") }}
            </el-button>
            <el-button @click="annuler">{{ $t("posts.edit.cancel") }}</el-button>
            <el-button
                    @click="enregistrerPDF"
                    type="primary"
                    class="inline"
                    v-loading="loading"
            >{{ $t("posts.view.print") }}
            </el-button>
        </template>
        <template>
            <div id="printNotePrive" v-loading="loading"
                 :element-loading-text="$t('portals.list.chargementDonnees')">
                <PrivateNoteImmo v-bind:post="post" v-if="sitimmoUser.univers === 'IMMO'"></PrivateNoteImmo>
                <PrivateNoteVo v-bind:post="post" v-else></PrivateNoteVo>
                <ubi-panel>
                    <el-container>
                        <el-aside width="30%"><h3>{{ $t("posts.privateNote.postPrivateNote") }}</h3></el-aside>
                        <el-main>
                            <div id="notePriveeInput">
                                <h4>{{ $t("posts.privateNote.contenueNote") }}</h4>
                                <br/>
                                <el-form id="inputNotePrive">
                                    <el-form-item>
                                        <el-input v-model="post.commentaire_prive" type="textarea" :rows="15">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                                <div id="inputNotePrivePrint">
                                    {{post.commentaire_prive}}
                                </div>
                                <span id="boutonsNotePrive">
                                <div class="text-right">
                                    <el-button
                                            @click="enregistrerModif"
                                            type="primary"
                                            class="inline"
                                            v-loading="loading"
                                    >{{ $t("posts.edit.save") }}
                                    </el-button>
                                    <el-button @click="annuler">{{ $t("posts.edit.cancel") }}</el-button>
                                </div>
                                </span>
                            </div>
                        </el-main>
                    </el-container>
                </ubi-panel>
            </div>
        </template>
    </ubi-page-container>
</template>

<script>
import UbiPanel from '../../components/Panel'
import PrivateNoteImmo from './components/PrivateNoteImmo'
import PrivateNoteVo from './components/PrivateNoteVo'
import {
  patchPost,
  getPostById
} from '@/services/posts'
import { gestionPDFNodePrive } from '@/services/pdf'
import html2pdf from 'html2pdf.js'
import UbiPageContainer from '@/components/PageContainer.vue'
export default {
  name: 'private-note',
  components: { UbiPageContainer, UbiPanel, PrivateNoteImmo, PrivateNoteVo },
  data () {
    return {
      post: [],
      loading: false
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  methods: {
    async fetchPost (id) {
      this.post = await getPostById(id)
    },
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    annuler () {
      this.eventAnalytics('annuler_privee')
      this.$router.go(-1)
    },
    async enregistrerPDF () {
      this.eventAnalytics('imprimer_privee')
      // this.loading = true;
      window.scrollTo(0, 0)
      const opt = {
        filename: this.post.reference + '_' + this.post.titre.replace(' ', '_'),
        margin: 1,
        html2canvas: { scale: 2, scrollX: 0, scrollY: 0, useCORS: true, allowTaint: true },
        jsPDF: {
          precision: 1,
          unite: 'in',
          orientation: 'portrait',
          format: 'a4',
          compress: true
        }
      }
      const element = document.getElementById('printNotePrive')
      let elementClone = element.cloneNode(true)
      elementClone = await gestionPDFNodePrive(elementClone)
      await html2pdf().set(opt).from(elementClone).save()
      this.loading = false
    },
    async enregistrerModif () {
      this.eventAnalytics('enregistrer_note_privee')
      this.loading = true
      let flux
      if (this.sitimmoUser.univers === 'IMMO') {
        flux = 'SAISIE_IMMO'
      } else {
        flux = 'SAISIE_VO'
      }
      const saveAnnonce = await patchPost(this.post, this.sitimmoUser.login, flux)
      if (saveAnnonce.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      } else {
        this.loading = false
        this.$message({ message: this.$t('posts.privateNote.messageSucces'), type: 'success' })
        this.$router.go(-1)
      }
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.fetchPost(this.$route.params.id)
    }
  }
}
</script>

<style scoped>
    #inputNotePrivePrint  {
        white-space: pre-line;
        border: 1px solid #ced4da;
        padding-left: 10px;
        padding-bottom: 20px;
        color: #606266;
        word-spacing: 5px;
        border-radius: 4px;
        min-height: 400px;
        display: none;
    }

    #inputNotePrive{
        display: block;
    }
</style>
